import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Social from '../section-components/social';

class TopBar extends Component {
	
    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
		<div>
          <div className="ltn__header-top-area section-bg-6 tt_bar">
			<div className="container">
				<div className="row">
				<div className="col-md-8">
					<div className="ltn__top-bar-menu">
					<ul>
						<li><a href="mailto:spesuccessbala@gmail.com"><i className="icon-mail" /> spesuccessbala@gmail.com</a></li>
						<li><a href=""><i className="icon-placeholder" /> No:1A,Cholan Street,Karunanithi Nagar,Ullagaram,Chennai-600 061</a></li>
					</ul>
					</div>
				</div>
				<div className="col-md-4">
					<div className="top-bar-right text-end">
					<div className="ltn__top-bar-menu">
						<ul>
						<li>
							<div className="ltn__social-media">
							<ul>
								<li><a href="https://www.facebook.com/people/Success-Property/61569702749127/" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
								<li><a href="https://wa.me/9962266482" target="blank" title="Whatsapp"><i className="fab fa-whatsapp" /></a></li>
								<li><a href="https://www.instagram.com/successpropertyenterprises/" title="Instagram"><i className="fab fa-instagram" /></a></li>
								<li><a href="https://www.youtube.com/@SuccessProperty1" title="Youtube"><i className="fab fa-youtube" /></a></li>
							</ul>
							</div>
						</li>
						</ul>
					</div>
					</div>
				</div>
				</div>
			</div>
			</div>
		</div>
        )
    }
}


export default TopBar